/* eslint-disable */
import session from './session';

export default {
    getLogList(filter) {
        return session.get(`device_log/${filter}`);
    },
    getLog(logId) {
        return session.get(`device_log/${logId}/`);
    },
    deleteLog(logId) {
        return session.delete(`device_log/${logId}/`);
    },
};